export default __webpack_public_path__ + "static/media/icon-material-error.18adf568.svg";